import * as angular from "angular";
import * as moment from "moment";
import "./complianceRing.scss";
import { RingStatus } from "./alcolock.enums";

class ComplianceRingComponentController implements angular.IComponentController {

    showLegend = true;

    okRingLabel = "All Clear";
    warningRingLabel = "Warnings";
    errorRingLabel = "Errors";

    okRing: number;
    warningRing: number;
    errorRing: number;

    okRingPercentage: number;
    warningRingPercentage: number;
    errorRingPercentage: number;

    okRingOffset: number;
    warningRingOffset: number;
    errorRingOffset: number;

    totalRingSize: number;

    ringStatus: RingStatus;

    static $inject = ["$timeout"];

    constructor(private readonly $timeout: angular.ITimeoutService) {
    }

    $onInit() {

    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.okRingLabel = this.okRingLabel || "OK";
        this.warningRingLabel = this.warningRingLabel || "Warnings";
        this.errorRingLabel = this.errorRingLabel || "Errors";

        this.$timeout(() => {
            this.update();
        });
    }

    // ---------------------

    private update() {
        this.totalRingSize = this.okRing + this.warningRing + this.errorRing;

        ////console.log(this.totalRingSize, this.okRing, this.warningRing, this.errorRing);

        this.okRingPercentage = Math.round(this.okRing * 100 / this.totalRingSize);
        this.warningRingPercentage = Math.round(this.warningRing * 100 / this.totalRingSize);
        this.errorRingPercentage = Math.round(this.errorRing * 100 / this.totalRingSize);
        
        this.okRingOffset = 0;
        this.warningRingOffset = this.okRingPercentage;
        this.errorRingOffset = this.warningRingPercentage + this.warningRingOffset;

        if (this.totalRingSize === 0)
        {
            this.ringStatus = RingStatus.NoData
        }
        else if (this.errorRing > 0) {
            this.ringStatus = RingStatus.Error;
        }
        else if (this.warningRing > 0) {
            this.ringStatus = RingStatus.Warning;
        }
        else {
            this.ringStatus = RingStatus.OK;
        }
    }
}

export class ComplianceRingComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            "okRing": "<",
            "warningRing": "<",
            "errorRing": "<",

            "okRingLabel": "@",
            "warningRingLabel": "@",
            "errorRingLabel": "@",

            "showLegend": "<?"
        };

        this.controller = ComplianceRingComponentController;
        this.template = require("./complianceRing.html");
    }
}
